module.exports = ".btn-group.btn-group-toggle .btn {\n  border: 1px solid #dddddd;\n  color: #dddddd;\n  padding: 3px 12px;\n  min-width: 80px; }\n  .btn-group.btn-group-toggle .btn.active {\n    color: #252525; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/subscription/modals/subscription-modal/subscription-period-change/subscription-period-change.scss
// module id = ./web/modern/components/subscription/modals/subscription-modal/subscription-period-change/subscription-period-change.scss
// module chunks = 0